import { logStdout } from "../../../shared/utils";
import { Printer, NewPrinter } from "./";
const old_printer = new Printer();
const new_printer = new NewPrinter();
const os = window.require("os");
const exec = window.require("child_process").exec;

export function detectPrinter() {
  return new Promise((resolve, reject) => {
    const interfaces = os.networkInterfaces();
    let ipAddress = { ip10: undefined, ip192: undefined };
    for (let id in interfaces) {
      for (let idy in interfaces[id]) {
        if (interfaces[id][idy].family === "IPv4") {
          if (interfaces[id][idy].address.indexOf("192.168.50.") >= 0) {
            ipAddress.ip192 = "192.168.50.2";
          }
          if (interfaces[id][idy].address.indexOf("10.42.0.") >= 0) {
            ipAddress.ip10 = "10.42.0.1";
          }
        }
      }
    }
    logStdout("printer ip address", ipAddress);
    if (!ipAddress.ip192 && !ipAddress.ip10) {
      return reject({ status: "no_printer" });
    }

    const tryFetch = (ip) =>
      fetch(`http://${ip}:3000/s`).then((res) => (res.ok ? ip : Promise.reject()));

    if (ipAddress.ip192) {
      tryFetch(ipAddress.ip192)
        .then(resolve)
        .catch(() => {
          if (ipAddress.ip10) {
            return tryFetch(ipAddress.ip10)
              .then(resolve)
              .catch(() => reject(""));
          }
          return reject({ status: "no_printer" });
        });
    } else if (ipAddress.ip10) {
      tryFetch(ipAddress.ip10)
        .then(resolve)
        .catch(() => reject({ status: "no_printer" }));
    }
  });
}

function printUsb(pdfPath) {
  return new Promise((resolve, reject) => {
    exec(`lpr ${pdfPath}`, (err) => {
      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
}

export default (options, callback) => {
  let { pdfPath, printConnection, sizes } = options;

  if (printConnection === "printer-USB") {
    return printUsb(pdfPath)
      .then(() => callback && callback())
      .catch((err) => callback && callback(err));
  } else {
    return detectPrinter()
      .then((ip) =>
        fetch(`http://${ip}:3000/version`)
          .then((res) => ({ ip, isNew: res.ok }))
          .then(({ ip, isNew }) =>
            (isNew ? new_printer : old_printer)
              .print(ip, pdfPath, sizes)
              .then(() => {
                if (callback) callback();
              })
              .catch((e) => {
                if (callback) callback(e);
              })
          )
      )
      .catch((e) => callback(e));
  }
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/printer/print.js